import { render, staticRenderFns } from "./SlideList.vue?vue&type=template&id=1682b18d&"
import script from "./SlideList.vue?vue&type=script&lang=js&"
export * from "./SlideList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports